import React from 'react'
import { useOptaWidgetStart } from '../../cricket-match-centre/useOptaWidgetStart'
import { AflFixturesWidgetContainer } from './AflFixturesWidget.styled'

export interface AflFixturesWidgetProps {}
export const AflFixturesWidget = ({}: AflFixturesWidgetProps) => {
    useOptaWidgetStart()
    return (
        <AflFixturesWidgetContainer>
            <opta-widget
                widget="fixtures"
                template="normal"
                //change to 12039 for finals
                competition="12038"
                season="2023"
                show_venue="true"
                match_status="all"
                grouping="round"
                show_grouping="true"
                navigation="tabs_more"
                default_nav="1"
                show_date_picker="true"
                start_on_current="true"
                sub_grouping="date"
                show_subgrouping="true"
                order_by="date_ascending"
                away_team_first="false"
                show_crests="true"
                date_format="ll"
                time_format="HH:mm"
                month_date_format="MMMM"
                show_logo="false"
                show_title="false"
                breakpoints="400,768"
                sport="afl"
                match_link="/sport/afl/match-centre"
                image_size="medium"
                pre_match="true"
            ></opta-widget>
        </AflFixturesWidgetContainer>
    )
}
